import React from 'react';
import { Trans } from '@lingui/macro';
import { Text } from '@oms/ui-text';
import { Box } from '@oms/ui-box';
import * as S from './styles';

export default (item: any) => (
  <Box as="article" py={2} px={4}>
    <div>
      <S.Logo
        className="logo"
        src={`https://prod.www.static.oms.no/logos/${item.LOGO_FILENAME}`}
        alt={`Logo for ${item.COMPANY_NAME || item.ITEM}`}
      />
      <Text as="h3" variant="heading5" mb={2}>
        <Trans>Company description</Trans>
      </Text>
    </div>
    <Text variant="body2">{item.DESCRIPTION_NO}</Text>
  </Box>
);
